//In your project, when a user searches for a city (example: New York),
//it should display the name of the city
//on the result page and the current temperature of the city.

function displayCity() {
  tempFahrenheit.classList.remove("active");
  tempFahrenheit.classList.add("fahrenheit");
  tempCelsius.classList.add("active");
  tempCelsius.classList.remove("fahrenheit");
  let enterCity = document.querySelector("#city-input").value; //input value is get
  console.log(enterCity);
  //let h1 = document.querySelector("#city"); //city filed is selected
  //h1.innerHTML = enterCity; //entered value is displayed

  let apiKey = "15128a6c48ef727e6b88a56a616ef153";
  let apiURL = `https://api.openweathermap.org/data/2.5/weather?q=${enterCity}&appid=${apiKey}&units=metric`;
  axios.get(apiURL).then(getTemp);
}

function functionDate(timestamp) {
  let date = new Date(timestamp);
  let hours = date.getHours();
  if (hours < 10) {
    hours = `0${hours}`;
  }
  let minutes = date.getMinutes();
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  let day = days[date.getDay()];
  return `${day}, ${hours}:${minutes}`;
}

function getTemp(response) {
  let temp = document.querySelector("#c"); //temperature field is selected
  celsiusTemp =
    `${Math.round(response.data.main.temp)}` +
    `<sup class="units">&nbsp°C</sup>`;
  console.log(celsiusTemp);
  temp.innerHTML = celsiusTemp;
  //temperature field is displayed

  let city = document.querySelector("#city");
  city.innerHTML = response.data.name;
  let description = document.querySelector("#description");
  description.innerHTML = response.data.weather[0].description;
  let humidity = document.querySelector("#humidity");
  humidity.innerHTML =
    `Humidity:&nbsp` + `${response.data.main.humidity}` + `%`;
  let wind = document.querySelector("#wind");
  wind.innerHTML = `Wind:&nbsp` + Math.round(response.data.wind.speed) + `km/h`;
  let date = document.querySelector("#date");
  date.innerHTML = functionDate(response.data.dt * 1000);
  let icon = document.querySelector("#icon");
  icon.setAttribute(
    "src",
    `http://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`
  );
  icon.setAttribute("alt", description.innerHTML);

  function getForecast(coordinates) {
    console.log(coordinates);

    let apiKey = "15128a6c48ef727e6b88a56a616ef153";

    let apiURL = `https://api.openweathermap.org/data/2.5/onecall?lat=${coordinates.lat}&lon=${coordinates.lon}&appid=${apiKey}&units=metric`;

    let apiURL1 = `https://api.openweathermap.org/data/2.5/onecall?lat=${coordinates.lat}&lon=${coordinates.lon}&appid=${apiKey}&units=imperial`;

    axios.get(apiURL).then(displayForecast);

    function tempFahrenheitDisplay() {
      axios.get(apiURL1).then(displayForecast);

      console.log(apiURL1);
      console.log("Fahrenheit");
      //getForecast(response.data.coord);
    }
    function tempCelsiusDisplay() {
      axios.get(apiURL).then(displayForecast);

      console.log(apiURL);
      console.log("Celsius");
      //getForecast(response.data.coord);
    }
    tempFahrenheit.addEventListener("click", tempFahrenheitDisplay);
    tempCelsius.addEventListener("click", tempCelsiusDisplay);
  }

  getForecast(response.data.coord);
}

function handlePosition(position) {
  let apiKey = "15128a6c48ef727e6b88a56a616ef153";
  let lat = position.coords.latitude;
  console.log(lat);
  let lon = position.coords.longitude;
  console.log(lon);
  function logCity(response) {
    console.log(response.data.name);
  }
  let apiUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric`;

  axios.get(apiUrl).then(logCity);
  axios.get(apiUrl).then(getTemp);
}

function geoLocation() {
  navigator.geolocation.getCurrentPosition(handlePosition);
}
geoLocation();
function showFahrenheitTemp(event) {
  event.preventDefault();
  tempCelsius.classList.remove("active");
  tempCelsius.classList.add("fahrenheit");
  tempFahrenheit.classList.add("active");
  tempFahrenheit.classList.remove("fahrenheit");
  let tmpFahrenheit = (celsiusTemp * 9) / 5 + 32;
  let tempElement = document.querySelector("#c");
  tempElement.innerHTML = Math.round(tmpFahrenheit);
}

function showCelsiusTemp(event) {
  event.preventDefault();
  tempFahrenheit.classList.remove("active");
  tempFahrenheit.classList.add("fahrenheit");
  tempCelsius.classList.add("active");
  tempCelsius.classList.remove("fahrenheit");
  let tempElement = document.querySelector("#c");
  tempElement.innerHTML = Math.round(celsiusTemp);
}

function formatDay(timestamp) {
  let date = new Date(timestamp * 1000);
  let day = date.getDay();
  let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  return days[day];
}

function displayForecast(response) {
  let forecast = response.data.daily;
  let forecastElement = document.querySelector("#forecast"); //forecast area is selected
  let days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sut", "Sun"];
  let forecastHTML = "";
  forecast.forEach(function (forecastDay, index) {
    if (index < 7) {
      forecastHTML =
        forecastHTML +
        ` <td>
            <div style="background-color: eige" id="day">
              ${formatDay(forecastDay.dt)}
              <br />
              <img
                src="http://openweathermap.org/img/wn/${
                  forecastDay.weather[0].icon
                }@2x.png"
                alt="It's sunny day!"
                width="40px"
                height="30px"
                id="img"
                ;
              />
              <br /><span id="max" class="max">${Math.round(
                forecastDay.temp.max
              )}°</span>&nbsp;
              <span id="min" class="min">${Math.round(
                forecastDay.temp.min
              )}°</span>
           </div>
           </td>`;
    }
    //console.log(forecastHTML);
  });

  forecastHTML =
    `<table style="text-align: center; width: 100%">` +
    forecastHTML +
    `</table>`;

  forecastElement.innerHTML = forecastHTML;
}

let celsiusTemp = null;
let searchButton = document.querySelector("#submit"); //select Search button
searchButton.addEventListener("click", displayCity);

let tempCelsius = document.querySelector("#celsius");
tempCelsius.addEventListener("click", showCelsiusTemp);

let tempFahrenheit = document.querySelector("#fahrenheit");
tempFahrenheit.addEventListener("click", showFahrenheitTemp);

let current = document.querySelector("#current");
current.addEventListener("click", geoLocation);

let input = document.querySelector("#city-input");
input.addEventListener("keypress", function (event) {
  if (event.key === "Enter") {
    displayCity();
  }
});

//displayForecast();

//displayCity();
//disableLocationRequest();
